import { styled as i, Box as s, useMediaQuery as l } from "@mui/material";
import f from "./DownloadButtons.js";
import u from "./DownloadLogo.js";
import { GAEventCategory as k } from "../constants/googleAnalytics.js";
import w from "../hooks/json/useFetchCurrentSeasonJson.js";
import _ from "../../temp-lib/components/share/apeiron/ApeironLoopVideo.js";
import L from "../../temp-lib/components/share/next/Image.js";
import T from "../../temp-lib/components/share/next/NextLink.js";
import m from "../../temp-lib/config/index.js";
import { DEFAULT_ANIMATE_DURATION as $ } from "../../temp-lib/constants/layout.js";
import d from "../../temp-lib/styles/theme.js";
import y from "../../ui-lib/components/ApeironBattleDemoTitle.js";
import { useTranslation as A } from "react-i18next";
import { jsxs as a, jsx as r, Fragment as c } from "react/jsx-runtime";
const D = i(s)`
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;

  ${(e) => e.theme.breakpoints.up("res480")} {
    height: 1080px;
  }
  ${(e) => e.theme.breakpoints.down("res480")} {
    height: 900px;
  }
`, E = i(L)`
  aspect-ratio: 1080 / 740;
  min-height: 100%;
  filter: brightness(0.95) contrast(1.05) saturate(1.05);
  position: absolute;
`, N = i(_)`
  filter: contrast(1.05) saturate(1.1);
  height: 1080px;
  object-fit: cover;
  position: absolute;
  width: 100%;
`, B = i(u)`
  margin-top: 130px;
`, v = i(y)`
  align-self: flex-start;
  position: relative;
  ${(e) => e.theme.breakpoints.up("res1024")} {
    margin: 45px 0px 0px 90px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    margin: 40px 0px 0px 20px;
  }
`, C = i(s)`
  height: 64px;
  ${(e) => e.theme.breakpoints.up("res1024")} {
    margin: 45px 0px 0px 90px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    margin: 40px 0px 0px 20px;
  }
`, I = i(s)`
  display: flex;
  flex-direction: column;

  ${(e) => e.theme.breakpoints.up("res1024")} {
    align-items: flex-end;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    align-items: center;
  }
`, x = i(T)`
  font-weight: 400;
  margin-right: 20px;
  margin-top: 15px;
  position: relative;
  text-decoration: underline;
  text-shadow: 2px 2px 10px #00000066;
  transition: color ${$}ms;

  :hover {
    color: #f1b535;
  }
`, W = (e) => {
  const {
    infoList: g,
    showTitle: h
  } = e, p = l(d.breakpoints.down("res768")), b = l(d.breakpoints.down("res480")), {
    t: n
  } = A(), {
    data: o
  } = w(), t = p ? o == null ? void 0 : o.breakpoint.mobile : o == null ? void 0 : o.breakpoint.desktop;
  return /* @__PURE__ */ a(D, {
    children: [t && (p ? /* @__PURE__ */ r(E, {
      src: t.background,
      priority: !0
    }) : /* @__PURE__ */ r(N, {
      src: t.background,
      playbackRate: 1.5,
      deferUntilIdle: !0
    })), h ? /* @__PURE__ */ r(v, {
      apeironTitle: n("battle_demo.download.page_title"),
      title: n("battle_demo.download.page_title")
    }) : /* @__PURE__ */ r(C, {}), o && t && /* @__PURE__ */ a(c, {
      children: [/* @__PURE__ */ r(B, {
        barColor: t.barColor,
        barSide: t.barSide,
        logo: t.logo,
        name: o.name,
        title: o.title
      }), /* @__PURE__ */ a(I, {
        children: [/* @__PURE__ */ r(f, {
          analytic: {
            emitById: !0,
            event: k.Download
          },
          infoBackground: t.barVersion,
          infoList: g
        }), !b && /* @__PURE__ */ a(c, {
          children: [/* @__PURE__ */ r(x, {
            href: m.EXTERNAL_URL.NEWS,
            target: "_blank",
            children: `${n("download.release_note")} >>`
          }), /* @__PURE__ */ r(x, {
            href: m.EXTERNAL_URL.FAQ,
            target: "_blank",
            children: `${n("download.faq")} >>`
          })]
        })]
      })]
    })]
  });
};
export {
  W as default
};
//# sourceMappingURL=DownloadSection.js.map
